import { render, staticRenderFns } from "./identificacion-sustancias-editar.vue?vue&type=template&id=b9dbcd88&scoped=true&"
import script from "./identificacion-sustancias-editar.vue?vue&type=script&lang=js&"
export * from "./identificacion-sustancias-editar.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-sustancias-editar.vue?vue&type=style&index=0&id=b9dbcd88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dbcd88",
  null
  
)

export default component.exports